<template>
  <div>
    <b-navbar toggleable="md" class="ew-navbar ew-white" v-bind:class="{ navbarPrimary: ((location === 'ew-dash') && isLoging) }">

      <div class="container">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-navbar-brand to="/dashboard" v-if="isLoging && location === 'ew-dash'">
          <img class="ew-navbar-logo" src="@/assets/images/logo-ew.png" alt="Logo Moovet">
        </b-navbar-brand>

        <b-navbar-brand to="/dashboard" v-if="isLoging && location === 'ew-home'">
          <img class="ew-navbar-logo" src="@/assets/images/logo-ew.png" alt="Logo Moovet">
        </b-navbar-brand>


        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav class="ml-auto">
            <template v-if="isLoging && location ==='ew-dash'">

              <form class="form-inline mr-2" v-if="searchVisible" @submit.prevent="track(guide)">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm rastrear-1" placeholder="N° de guía" v-model="guide" required>
                  <div class="input-group-append">
                    <button class="btn btn-primary btn-sm ew-btn-search" type="submit">
                      <img src="@/assets/images/Buscar.svg" alt="" class="ew-navbar-icon-sm">
                    </button>
                  </div>
                </div>
              </form>

              <a class="nav-item nav-link font-weight-bold" href="#" @click.prevent="toggleSearch()">
                <img src="@/assets/images/rastreo-blanco.png" class="ew-navbar-icon"> Rastrear
              </a>
              <div class="ew-custom-dropdown-navbar">
                <div class="ew-help-dropdown">
                <b-nav-item-dropdown class="ew-navbar-dropdown" variant="link" no-caret>
                <template slot="button-content">
                  <img src="@/assets/images/Ayuda-Preguntas.svg" alt="" class="pr-3">
                </template>

                <b-dropdown-item class="ew-item-dropdown-navbar">Guía de inicio</b-dropdown-item>
                <b-dropdown-item to="/contactanos" class="ew-item-dropdown-navbar">
                  Contactanos
                </b-dropdown-item>
                </b-nav-item-dropdown>

                </div>
              </div>

              <div class="ew-custom-dropdown-navbar">
                <b-nav-item-dropdown class="ew-navbar-dropdown py-2" variant="link" right>
                <template slot="button-content">
                <span class="font-weight-bold ew-name-user">{{ user.firstName + ' ' + user.lastName }}</span>
                </template>
                <b-dropdown-item to="/configuracion" class="ew-item-dropdown-navbar  ew-item-navbar--image text-right ew-item-image-engrane">
                  Configuración
                </b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-shipment" to="/dashboard">Mis Envíos</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-integracion">Integracíones</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-facturacion">Facturación</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-direcciones" to="/addresses">Direcciones</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-prepaids" to="/prepaids">Monedero</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-pago">Métodos de pago</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-signout" @click="signOut">Cerrar Sesión</b-dropdown-item>
                </b-nav-item-dropdown>
              </div>

            </template>

            <template v-if="isLoging || location==='ew-home'" >

              <form class="form-inline mr-2" v-if="searchVisible && location === 'ew-home'" @submit.prevent="track(guide)">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm rastrear-1" placeholder="N° de guía" v-model="guide" required>
                  <div class="input-group-append">
                    <button class="btn btn-primary btn-sm" type="submit">
                      <img src="@/assets/images/Buscar.svg" alt="" class="ew-navbar-icon-sm">
                    </button>
                  </div>
                </div>
              </form>

              <a class="nav-item nav-link font-weight-bold mr-3" href="#" @click.prevent="toggleSearch()" v-if="location === 'ew-home'">
                <img src="@/assets/images/Rastrear.svg" class="ew-navbar-icon"> Rastrear
              </a>

              <router-link class="nav-item nav-link font-weight-bold mr-3" to="/dashboard" v-if="isLoging  && location === 'ew-home'">Inicio </router-link>
              <router-link class="nav-item nav-link font-weight-bold mr-3" to="/" v-if="!isLoging  && location === 'ew-home' ">Inicio </router-link>
              <router-link class="nav-item nav-link font-weight-bold mr-3" to="/blog" v-if="location === 'ew-home'">Blog</router-link>
              <router-link class="nav-item nav-link text-primary font-weight-bold" to="/signin" v-if="!isLoging">
                <img src="@/assets/images/Iniciar sesion.svg" alt="" class="ew-navbar-icon mr-1"> Iniciar sesión
              </router-link>
              <div class="ew-custom-dropdown-navbar">
                <b-nav-item-dropdown class="ew-navbar-dropdown py-2" variant="link" v-if="isLoging  && location === 'ew-home'" right>
                <template slot="button-content">
                  <span class="font-weight-bold ew-name-user">{{ user.firstName + ' ' + user.lastName }}</span>
                </template>
                <b-dropdown-item to="/configuracion" class="ew-item-dropdown-navbar ew-item-image-engrane ew-item-navbar--image text-right">
                  Configuración
                </b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-shipment" to="/dashboard">Mis Envíos</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-integracion">Integracíones</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-facturacion">Facturacion</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-direcciones">Direcciones</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-pago">Metodos de pago</b-dropdown-item>
                <b-dropdown-item class="ew-item-dropdown-navbar ew-item-navbar--image text-right ew-item-image-signout" @click="signOut">Cerrar Sesión</b-dropdown-item>
              </b-nav-item-dropdown>
              </div>
            </template>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>

    <b-modal ref="trackingModal" title="Resultado del Envío" size="lg" ok-only>
      <div v-if="isLoadingTracking">
        Cargando...
      </div>
      <div v-else>
        <div class="alert alert-warning" v-if="trackingNotFound">
          El N° de guía {{ guide }} no ha sido localizado.
        </div>

        <template v-if="trackingResult && !trackingNotFound">
          <div v-if="trackingResult.type === 'dhl'">
              <div class="bg-light border px-3 py-3 mb-3">
              <div class="row">
                <div class="col">
                  <div class="font-weight-bold">N° de guía: {{ trackingResult.guide }}</div>
                  <div class="font-weight-bold text-primary">{{ eventsDescrip(lastEvent(trackingEventsByDate()), trackingEventsByDate()) }}</div>
                </div>

                <div class="col">
                  <div class="font-weight-bold">
                    {{ formatDate(trackingResult.date) }}
                  </div>
                  <div>
                    <div class="font-weight-bold">Enviado desde:</div>
                    <div>{{trackingResult.shipper.city}}</div>

                    <div class="font-weight-bold">Enviado hacia:</div>
                    <div>{{trackingResult.consignee.city}}</div>
                  </div>
                </div>

                <div class="col-auto font-weight-bold">
                  {{ trackingResult.package }} Paquete
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-3" v-for="(te, i) of trackingEventsByDate()" :key="i">
                <thead class="thead-light border">
                  <th>{{ te[0].date }}</th>
                  <th>Ubicación</th>
                  <th>Hora</th>
                  <th>Paquete</th>
                </thead>

                <tbody>
                  <tr v-for="(e, i) of te" :key="i">
                    <td>{{ e.event.status }}</td>
                    <td>{{ e.event.location }}</td>
                    <td>{{ e.event.time }}</td>
                    <td class="text-right">{{ trackingResult.package }} Paquete</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="trackingResult.type === 'redpack'">
              <div class="bg-light border px-3 py-3 mb-3">
              <div class="row">
                <div class="col">
                  <div class="font-weight-bold">N° de guía: {{ trackingResult.guide }}</div>
                  <div class="font-weight-bold text-primary">ENTREGADO</div>
                </div>

                <div class="col">
                  <div class="font-weight-bold">
                    {{ formatDate(trackingResult.date) }}
                  </div>
                  <div>
                    <div class="font-weight-bold">Enviado desde:</div>
                    <div>{{trackingResult.shipper.city}}</div>

                    <div class="font-weight-bold">Enviado hacia:</div>
                    <div>{{trackingResult.consignee.city}}</div>
                  </div>
                </div>

                <div class="col-auto font-weight-bold">
                  {{ trackingResult.package }} Paquete
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-3" v-for="(te, i) of trackingEventsByDate()" :key="i">
                <thead class="thead-light border">
                  <th>{{ te[0].date }}</th>
                  <th>Ubicación</th>
                  <th>Paquete</th>
                </thead>

                <tbody>
                  <tr v-for="(e, i) of te" :key="i">
                    <td>{{ e.event.status }}</td>
                    <td>{{ e.event.location }}</td>
                    <td class="text-right">{{ trackingResult.package }} Paquete</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="trackingResult.type === 'fedex'">
              <div class="bg-light border px-3 py-3 mb-3">
              <div class="row">
                <div class="col">
                  <div class="font-weight-bold">N° de guía: {{ trackingResult.guide }}</div>
                  <div class="font-weight-bold text-primary">ENTREGADO</div>
                </div>

                <div class="col">
                  <div class="font-weight-bold">
                    {{ formatDate(trackingResult.date) }}
                  </div>
                  <div>
                    <div class="font-weight-bold">Enviado desde:</div>
                    <div>{{trackingResult.shipper.city}}</div>

                    <div class="font-weight-bold">Enviado hacia:</div>
                    <div>{{trackingResult.consignee.city}}</div>
                  </div>
                </div>

                <div class="col-auto font-weight-bold">
                  {{ trackingResult.package }} Paquete
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-3" v-for="(te, i) of trackingEventsByDate()" :key="i">
                <thead class="thead-light border">
                  <th>{{ te[0].date }}</th>
                  <th>Ubicación</th>
                  <th>Paquete</th>
                </thead>

                <tbody>
                  <tr v-for="(e, i) of te" :key="i">
                    <td>{{ e.event.status }}</td>
                    <td>{{ e.event.location }}</td>
                    <td class="text-right">{{ trackingResult.package }} Paquete</td>
                  </tr>
                </tbody>
              </table>
              {{user}}
            </div>
          </div>

        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import commons from '../commons';
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/es';

export default {
  name: 'Navbar',
  data () {
    return {
      location:null,/**ew-home, ew-dash */
      isLoging:false,
      path:null,
      searchVisible: false,
      guide: '',
      trackingResult: null,
      isLoadingTracking: false,
      trackingNotFound: false
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('ddd D [de] MMMM [de] YYYY')
    },
    track (guide) {
      this.trackingNotFound = false
      if (guide.length > 6) {
        this.isLoadingTracking = true
        this.$refs.trackingModal.show()
        const url = `${commons.apiURL}/api/v1/tracking`
        axios
          .post(url, { guide_number: guide })
          .then(response => {
            console.log(response.data)
            if (response.data.status === 404) {
              this.trackingNotFound = true
            } else {
              this.trackingResult = response.data
            }
          })
          .catch(() => {})
          .finally(() => {
            this.isLoadingTracking = false
          })
      }
    },
    signOut () {

        this.isLoging = false
        localStorage.clear()
        this.$router.push('/')
    },
    toggleSearch () {
      this.searchVisible = !this.searchVisible
    },
    trackingEventsByDate () {
      const events = {}
      this.trackingResult.shipment_event.map(e => {
        const date = e.date
        if (!events.hasOwnProperty(date)) {
          events[date] = []
        }
        events[date].push({
          date: this.formatDate(date),
          event: e
        })
      })
      console.log(events)
      return events
    },
    lastEvent(object){
      var last  = {};
      for (const key in object) {
        last = key;
      }
      return last
    },
    eventsDescrip(key, object){
      var listEvent = object[key].length -1;
      var list = object[key]
      return list[listEvent].event.status
    },
    getItemsNavbar(path){
     let items = [ '/', '/signup', '/signin', 'contactanos', '/servicios', '/quienes-somos', '/terminos-de-servicio', '/politicas-de-privacidad', '/thank-page','/preguntas-frecuentes', '/shipment/new']
     if (items.indexOf(path) >= 0) {
       this.location = "ew-home"
     } else {
       this.location = "ew-dash"
     }
    },
    ...mapActions(['getUser'])
  },
  computed: {
    ...mapGetters(['user']),
  },
  created () {
    console.log("Esta es la ruta: ",this.$route.path)
      this.path = this.$route.path;
      this.getItemsNavbar(this.path)
      console.log("this.location: ",this.location)
      if (localStorage.getItem('ew-user-id') !== null) {
        console.log("Si esta logueado")
        this.isLoging = true;
      } else {
        console.log("No esta logueadooooooo")
        this.isLoging = false;
      }
    this.getUser()
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


@import "../assets/styles/variables";
@font-face {
    font-family: 'Source Sans Pro', sans-serif;;
    src: url('../assets/fonts/Source_Sans_Pro/SourceSansPro-Bold.ttf');
}

.ew-navbar-dropdown{
  a{
    &:hover{
      text-decoration: none;
    }
  }

}
.navbar-light {
  .navbar-nav{
     .nav-link {
      color: #333;
      font-weight: 600 !important;
      padding-left: 0rem !important;
      padding-right: 0rem !important;
      padding-bottom: 0.5rem !important;
      &:hover {
        text-decoration: none;
        border-bottom: 3px solid;
        border-bottom-color: $primary;
      }
      &:focus{
        text-decoration: none;
      }
      span{
        color: $primary;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}


.navbarPrimary{
  .navbar-nav{
    .nav-link {
      color: #ffffff;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 900!important;
      text-transform: lowercase;

      &:hover {
        color: #ffffff;
        text-decoration: none;
      }

      &:focus{
        text-decoration: none;
      }

      span{
        color: #ffffff;
      }
    }
  }
}

.ew-btn-search{
  border-color: #ffffff;
  border-left: none;
}

@media (min-width: 425px) {
  .ew-navbar-logo {
    height: 2.4rem;
  }
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {

}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
    .navbar-light .navbar-nav .nav-link {
    font-size: 0.855rem;
  }

  .rastrear-1 {
    width: auto;
    font-size: 0.855rem;
  }
  .ew-navbar-icon-sm {
    height: 1rem;
    width: 1rem;
  }

  .ew-navbar-logo {
    height: 2.4rem;
  }
  .ew-name-user{
    font-size: 0.8rem;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
    .navbar-light .navbar-nav .nav-link {
    font-size: 0.9888rem;
  }
  .rastrear-1{
    width: 8rem;
    font-size: 0.9888rem;
  }
  .ew-navbar-icon-sm {
    height: 0.7rem;
    width: 0.7rem;
  }

  .ew-navbar-logo {
    height: 2.2rem;
  }

  .ew-name-user{
    font-size: 0.92rem;
  }
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
  .navbar-light .navbar-nav .nav-link {
      font-size: 1.188rem;
  }
  .rastrear-1{
    width: 8rem;
    font-size: 1.188rem;
  }
  .ew-navbar-logo {
    height: 3.4rem;
  }

  .ew-name-user{
    font-size: 1.13rem;
  }

}

.ew-item-dropdown-navbar{
  font-weight: 500;
  color: #777c82;
  &:hover{
    text-decoration: none;
    color: $primary;
    background-color: rgba(206, 199, 199, 0.3);
  }
  &:focus{
    text-decoration: none;
    color: $primary;
    outline: none;
    background-color: rgba(206, 199, 199, 0.3);
  }

  &.active{
    text-decoration: none;
    color: $primary;
    outline: none;
    background-color:transparentize($primary, 0.85);
  }
}
.ew-item-navbar--image{

  padding-bottom: 0.5rem;
  padding-left: 4rem;
  background-position: center left 0.6rem;
  background-repeat: no-repeat;
  background-size: 25px 25px;
}

.ew-item-image-shipment{
  background-image: url("../assets/images/envios-gris.png");

  &:hover{
      background-image: url("../assets/images/envios-naranja.png");
  }

}

.ew-item-image-integracion{
  background-image: url("../assets/images/rompecabeza-gris.png");
  &:hover{
      background-image: url("../assets/images/rompecabezas-naranja.png");
  }

}

.ew-item-image-facturacion{
  background-image: url("../assets/images/moneda-gris.png");

  &:hover{
    background-image: url("../assets/images/moneda-naranja.png");
  }

}

.ew-item-image-direcciones{
  background-image: url("../assets/images/directorio-gris.png");
  &:hover{
    background-image: url("../assets/images/directorio-naranja.png");
  }

}
.ew-item-image-prepaids{
  background-image: url("../assets/images/moneda-gris.png");
  &:hover{
    background-image: url("../assets/images/moneda-naranja.png");
  }

}

.ew-item-image-pago{
  background-image: url("../assets/images/tarjeta-gris.png");

  &:hover{
    background-image: url("../assets/images/tarjeta-naranja.png");
  }

}


.ew-item-image-engrane{
  background-image: url("../assets/images/engrane-gris.png");

  &:hover{
    background-image: url("../assets/images/engrane-naranja.png");
  }

}

.ew-item-image-signout{
  background-image: url("../assets/images/signout_gris.svg");

  &:hover{
    background-image: url("../assets/images/signout_naranja.svg");
  }

}

.navbarPrimary{
    background-color: $primary;
    padding:0;
    .navbar-light .navbar-nav .nav-link {
      color: #fff;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 900!important;
      text-transform: lowercase;
    }
    .navbar-light .navbar-nav .nav-link:hover {
      color: #fff;
    }
}
.form-inline.mr-2 .input-group{
    height: 30px;
}
.rastrear-1::-webkit-input-placeholder {
    font-size:1rem;
}
.rastrear-1::-moz-placeholder {
  font-size:1rem;
}
.rastrear-1:-ms-input-placeholder {
  font-size:1rem;
}
.rastrear-1:-moz-placeholder {
  font-size:1rem;
}
.form-inline.mr-2 .btn-sm {
    width: 30px;
    height: 30px;
    line-height: 10px;
}
@media only screen and (max-width: 767px){
.rastrear-1{
  line-height: 30px;
  height: 30px;
}
}
@media only screen and (max-width: 425px){
.navbarPrimary{
    padding-left: .8rem;
    padding-top: .2rem;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue